// Korean translations for the 6 experience roles (index-aligned with EXPERIENCE in portfolio.js)
export const EXPERIENCE_KO = [
  {
    role: "자바 소프트웨어 개발자",
    type: "계약직",
    bullets: [
      "Java Spring(JSF & Hibernate JPA)과 PostgreSQL을 사용하여 LG U+ Nerget 및 StarHub 통신 시스템과 엔터프라이즈 BSS 플랫폼을 통합했습니다.",
      "EC2, RDS, VPC, Route 53 및 EKS Kubernetes 클러스터(GitHub Actions & ArgoCD)를 포함한 AWS 클라우드 인프라를 운영하며 운영 환경 애플리케이션을 지원했습니다.",
      "Cisco ISR 라우터, Catalyst 스위치, ASA 방화벽을 구성하고 유지 관리했습니다.",
      "교차 기능 팀과 협업하여 엔터프라이즈 시스템 통합을 일정에 맞춰 제공했습니다.",
    ],
  },
  {
    role: "소프트웨어 아키텍트",
    type: "기간제 프리랜스",
    bullets: [
      "인증, 커뮤니티, 리뷰, 마켓플레이스 서비스를 제공하는 HiddenTag Global 플랫폼의 백엔드 아키텍처를 설계했습니다.",
      "Spring Boot, Hibernate JPA, MyBatis, MySQL을 사용하여 RESTful API와 데이터베이스 아키텍처를 개발했습니다.",
      "애플리케이션 배포를 기존 Tomcat 서버에서 AWS의 Docker 기반 컨테이너 인프라로 마이그레이션했습니다.",
      "HiddenTag Global 플랫폼의 성공적인 운영 출시를 지원했습니다.",
    ],
  },
  {
    role: "애플리케이션 아키텍트",
    type: "계약직",
    bullets: [
      "AWS에서 SEHATI 바레인 국가건강보험 시스템을 현대화: JDK 7 → 8, Tomcat 7 → 9, Oracle RDS 12c → 19c.",
      "차세대 GS Postbox 시스템을 위해 GitOps / ArgoCD Kubernetes 환경에서 CI/CD 파이프라인과 배포 자동화를 구축했습니다.",
      "Adobe AEM 프레임워크 기반 LG U+ 디지털 카탈로그 시스템에 커스텀 Maven 프로필로 Jenkins 배포 자동화를 구현했습니다.",
      "신한은행 The Next Project의 인터페이스 서비스(MCI / FEP / EAI 서비스 메시)를 관리·배포했습니다.",
      "차세대 한국 사회보장정보 시스템을 위한 MyBatis 기반 Java Batch 서비스를 개발했습니다.",
    ],
  },
  {
    role: "소프트웨어 개발자",
    type: "계약직",
    bullets: [
      "Middleblock 블록체인 플랫폼(Hyperledger Indy, Aries & Fabric)을 위한 Java Spring 통합 REST API 게이트웨이 서버를 개발했습니다.",
      "Hadoop, Spark, Hive, Django, React를 사용하여 여수 데이터 플래그십 프로젝트의 빅데이터 웨어하우스 인프라와 모니터링 플랫폼을 설계·구현했습니다.",
    ],
  },
  {
    role: "소프트웨어 개발자",
    type: "계약직",
    bullets: [
      "메인 센서 게이트웨이 백엔드를 Go에서 Java Spring(TCP/IP 소켓, gRPC, REST API)으로 마이그레이션하고 Kafka 기반 데이터 파이프라인을 구현했습니다.",
      "Apache Nifi와 Streamsets로 Kafka 파이프라인을 업그레이드하고, 고성 & 사천 관광 센서 IoT 대시보드(React, Java Spring, MariaDB)를 구축했습니다.",
      "여러 고객 애플리케이션을 지원하는 Docker 기반 AWS 운영 환경을 관리했습니다.",
    ],
  },
  {
    role: "AI 소프트웨어 개발자",
    type: "계약직",
    bullets: [
      "Java Spring, Angular, Python을 사용하여 KISA 정부 프로젝트용 MICUBE AI 시각화 도구 대시보드를 개발했습니다.",
      "진동 센서 데이터에 TensorFlow RMSE 모델을 적용해 대덕전자의 설비 예지보전 애플리케이션을 구축했습니다.",
      "TensorFlow Mask R-CNN을 사용하여 현대 충주 바이오센터의 컴퓨터 비전 암석 감지 애플리케이션을 개발했습니다.",
      "Hadoop, Kafka, Ambari, Linux 서버 인프라를 관리했습니다.",
    ],
  },
];
